import {
  Modal,
  ModalContent,
  ModalBody,
  ModalHeader,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

type InventoryErrorModalProps = {
  title: string;
  content: string;
  isOpen: boolean;
  onClose: () => void;
};

export default function InventoryErrorModal({
  title,
  content,
  isOpen,
  onClose,
}: InventoryErrorModalProps) {
  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="center">{title}</ModalHeader>
        <ModalBody>
          <Text textAlign="center">{content}</Text>
        </ModalBody>
        <ModalFooter
          borderTopWidth="1px"
          borderColor="gray.400"
          p={3}
          justifyContent="center"
          onClick={onClose}
        >
          重新選擇
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
